import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'isg-loader',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './isg-loader.component.html',
  styleUrl: './isg-loader.component.scss'
})
export class IsgLoaderComponent {
  options: AnimationOptions = {
    path: "/assets/json/isg_loader.json"
  };
}
